import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Careers from "../views/Careers.vue";
import Coop from "../views/Coop.vue";
import JobReq from "../views/JobReq.vue";
import Contact from "../views/Contact.vue";
import NotFound from "../views/NotFound.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: []
  },
  {
    path: "/about",
    name: "About",
    component: About,
    children: []
  },
  {
    path: "/careers",
    name: "Careers",
    component: Careers,
    children: []
  },
  {
    path: "/careers/co-ops",
    name: "Coop",
    component: Coop,
    children: []
  },
  {
    path: "/careers/:id",
    name: "JobReq",
    component: JobReq,
    beforeEnter(to, from, next) {
      // Add any route guards here if needed
      next();
    },
    children: []
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    children: []
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    children: []
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when route changes
    return { top: 0 }
  }
})

export default router;
